// Logo der Deutschen Post (Posthorn, Wikimedia Commons „Logo Deutsche Post 2019.svg“, quadratisch zugeschnitten) unter
// public/epost/post-logo.svg – fehlt die Datei, erscheint ein Briefumschlag.
import React, { forwardRef, useState } from 'react';
import { Envelope, type Icon, type IconProps } from '@phosphor-icons/react';

export const POST_LOGO_URL = '/epost/post-logo.svg';

const PostLogoKomp = forwardRef<SVGSVGElement, IconProps>(function PostLogo({ size = 16, ...rest }, ref) {
  const [fehlt, setFehlt] = useState(false);
  if (fehlt) return <Envelope ref={ref} size={size} {...rest} />;
  return <img src={POST_LOGO_URL} alt="" aria-hidden width={Number(size) || 16} height={Number(size) || 16} onError={() => setFehlt(true)} style={{ objectFit: 'contain', flexShrink: 0 }} />;
});

/** Als Phosphor-Icon nutzbar (Tabs, Widgets, Dialoge). */
export const PostLogo = PostLogoKomp as unknown as Icon;
